import { Injectable } from '@angular/core';
import { GoogleMapsService } from './googleMaps/google-maps.service';
import { UserDetails } from '@my-models/users';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '@my-env/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonServiceService {
  private currentLocation!: google.maps.LatLng;
  private apiUrl = 'assets/config/config.json';

  baseApiUrl = environment.crossDomainAPI;

  constructor(private googleMapsService: GoogleMapsService,
    private _authService: AuthService,
    private http: HttpClient) {

   }
 
  getPosition() {
    this.googleMapsService.load().then(() => {
      navigator.geolocation.getCurrentPosition((position) => {
        this.currentLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        if (this.currentLocation) {
          const oldData:UserDetails = this._authService.getUser();
          oldData.location.lat = this.currentLocation.lat();
          oldData.location.lng = this.currentLocation.lng();
          this._authService.updateUserDetails(oldData);
          console.log('current location updated!!');
        }
      });
    });
  }
  
  convertDateIntoUTC(newDate:Date){
    if (newDate) {
      let cnfDate: Date;
      const localDate = new Date(newDate);
      // Convert local date to UTC date
      const utcDate = new Date(Date.UTC(
        localDate.getFullYear(),
        localDate.getMonth(),
        localDate.getDate(),
        localDate.getHours(),
        localDate.getMinutes(),
        localDate.getSeconds(),
        localDate.getMilliseconds()
      ));
      cnfDate = utcDate;
      return cnfDate.toISOString();
    }
    else {
      return null
    }
  }
  getConfig(): Observable<any> {
    return this.http.get(this.apiUrl);
  }

  getAllCityBySearch(state: string, area: string): Observable<any> {
    return this.http.get<any>(``).pipe(
      map(response => response)
    );
  }
}
